import AOS from 'aos';

import './utils/vh.utils.js';
import './utils/parallax-on-view.utils.js';
import './utils/animate-on-view.utils';
import './utils/meta.utils.js';

import './components/meta/select.component.js';

import './components/marquee/_index.js';
import './components/swiper/_index.js';
import './components/cards/_index.js';
import './components/sections/_index.js';
import './components/animations/_index.js';

import './components/validation.component.js';

import './components/uploadFile.component.js';
import './components/range.component.js';
import './components/header.component.js';
import './components/inputs.component.js';
import './components/animations.component.js';
import './components/player.component.js';
import './components/search-sec.component.js';

import './components/connect.component.js';

import './components/our-mission.component.js';
import './components/join-us.component.js';
import './components/content-accordion.component.js';

import './libs/countUp.lib.js';
import './libs/smoothScrollbar.lib.js';


AOS.init({
  offset: 10,
  delay: 10,
  duration: 600,
  easing: 'ease-in-out',
  once: true,
  startEvent: 'DOMContentLoaded',
});


const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if(isSafari) document.body.classList.add('is-safari');


// Global subscribe btn
const globalSubscribeBtn = document.querySelector('.global-subscribe-btn');
if (globalSubscribeBtn) {
  const subscribeBtnActivation = {
    unit: 'vh', // 'vh' => value * viewport height, 'px' => value in pixels
    value: 1,
  };

  const getThresholdPx = () => (
    subscribeBtnActivation.unit === 'px'
      ? subscribeBtnActivation.value
      : window.innerHeight * subscribeBtnActivation.value
  );

  let thresholdPx = getThresholdPx();
  let isActive = false;
  let isTicking = false;

  const updateSubscribeBtnState = () => {
    isTicking = false;
    const shouldBeActive = window.scrollY >= thresholdPx;

    if (shouldBeActive === isActive) return;
    isActive = shouldBeActive;
    globalSubscribeBtn.classList.toggle('is-active', shouldBeActive);
  };

  const queueSubscribeBtnUpdate = () => {
    if (isTicking) return;
    isTicking = true;
    window.requestAnimationFrame(updateSubscribeBtnState);
  };

  const onResize = () => {
    thresholdPx = getThresholdPx();
    queueSubscribeBtnUpdate();
  };

  window.addEventListener('scroll', queueSubscribeBtnUpdate, { passive: true });
  window.addEventListener('resize', onResize);
  queueSubscribeBtnUpdate();
}
